import { useCallback } from 'react'
import { useTracking } from 'react-tracking'

import type { TrackingData } from '@ecomm/tracking-types/Data'
import type { ODMONPlan } from '@ecomm/tracking-types/Odmon'

export function useTrackOdmonPlanSelection() {
  const { trackEvent } = useTracking<TrackingData>()

  return useCallback(
    (plan: ODMONPlan, placement: 'cards' | 'chart' | 'modal') => {
      trackEvent({
        plan: plan,
        placement: placement,
        event: 'atc-plan-selection'
      })
    },
    [trackEvent]
  )
}
